import colors from 'colors'
import _Button from 'components/Button'
import { Corner4 } from 'components/Corner'
import images from 'images'
import React, { FC } from 'react'
import { animated } from 'react-spring'
import styled from 'styled-components'
import { useFadeIn } from 'utils/hooks'

const Container = styled(animated.div)``
const BodyContainer = styled.div`
  padding: 16px 0;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
`
const Desc = styled.p`
  margin: 16px 16px 0;
  padding: 16px;

  background-color: white;
  border-radius: 8px;
  color: ${colors.black};
`
const PosterContainer = styled.div`
  height: 340px;
  padding: 0 16px;
`
const Poster = styled.img.attrs({ src: images.intro })`
  height: 100%;
  width: auto;
`
const Button = styled(_Button)`
  margin: 16px 4px;
`

const Body: FC = () => {
  return (
    <BodyContainer>
      <Corner4 />
      <PosterContainer>
        <Poster />
      </PosterContainer>
      <Desc>
        あなたの「普段の日常生活での行動傾向」から投資タイプを診断します。仮想通貨投に興味はあるけど、何をすれば良いのか分からない方は、ぜひお試しください。
      </Desc>
    </BodyContainer>
  )
}

interface Props {
  onPressStart: () => void
}

const Intro: FC<Props> = ({ onPressStart }) => {
  const anim = useFadeIn()
  return (
    <Container style={anim}>
      <Body />
      <Button onClick={onPressStart}>スタート</Button>
    </Container>
  )
}

export default Intro
